import React from 'react';
import { NextPage } from 'next';

import PartnershipService from 'components/partnership/_index';

const Partnership: NextPage = () => {
  return <PartnershipService />;
};

export default Partnership;
